import { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import genericPlaylistIcon from '../assets/generic_playlist_icon.png';

export function usePlaylistArtwork(playlist) {
  const [artworkUrls, setArtworkUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchArtworks = async () => {
      setIsLoading(true);

      if (playlist.customArtworkUrl) {
        setArtworkUrls([playlist.customArtworkUrl]);
        setIsLoading(false);
        return;
      }

      const songIds = playlist.songIds || [];
      if (songIds.length === 0) {
        setArtworkUrls([genericPlaylistIcon]);
        setIsLoading(false);
        return;
      }

      const db = getFirestore();
      
      // 1. Fetch the first 10 song documents to have a good pool to select from
      const songIdsToFetch = songIds.slice(0, 10);
      const songPromises = songIdsToFetch.map(id => getDoc(doc(db, 'songs', id)));
      const songDocs = await Promise.all(songPromises);

      // 2. Filter out songs that don't exist or have been soft-deleted
      const validSongs = songDocs
        .map(docSnap => docSnap.exists() ? docSnap.data() : null)
        .filter(song => song && song.isDeleted !== true);

      // 3. Get the artwork URLs from the remaining valid songs
      const urls = validSongs
        .map(song => song.albumArtworkURL)
        .filter(url => url); // Filter out any songs that might not have artwork

      if (urls.length > 0) {
        // Take the first 4 valid artworks for the cover
        setArtworkUrls(urls.slice(0, 4));
      } else {
        // If no valid songs have artwork, use the generic icon
        setArtworkUrls([genericPlaylistIcon]);
      }

      setIsLoading(false);
    };

    if (playlist) {
      fetchArtworks();
    }
  }, [playlist]);

  return { artworkUrls, isLoading };
}